import { styled, Stack, Box } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

const gray500 = colors.gray500;
const blue500 = colors.blue500;

export const MainGrid = styled(Stack)(() => ({
  width: "100%",
  height: "100%",
}));

export const Title = styled("h2")(() => ({
  color: colors.gray500,
  fontFamily: "Manrope",
  fontSize: "22px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "28px",
  alignSelf: "stretch",
}));

export const Text = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: 14,
  color: gray500,
}));

export const EmailSentBoxContainer = styled(Box)(() => ({
  width: "65%",
  "@media (max-width: 1300px)": {
    width: "70%",
  },
  "@media (max-width: 1100px)": {
    width: "80%",
  },
  "@media (max-width: 600px)": {
    width: "100%",
  },
}));

export const ClickableText = styled("span")(() => ({
  font: "500 14px Manrope",
  color: blue500,
  cursor: "pointer",
}));
